import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeRegistrationWizardButtonName, trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {trackAmplitudeViewModal} from "../../tracking/amplitude/track_amplitude_view_modal";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {IAmplitudePhoneVerificationContext, trackAmplitudePhoneVerified} from "../../user/tracking/track_amplitude_phone_verified";
import {AmplitudeAuthLocation} from "./track_amplitude_auth_event";

export interface IRegistrationWizardTrackingContext {
    authPlacement: AmplitudeAuthPlacement | null;
    location: AmplitudeAuthLocation;
    itemId: number | null;
    propertyId: number | null;
}

export type RegistrationWizardStepToken = "auth" | "auth_phone" | "phone_verify" | "auth_name";

export const trackRegistrationWizardFormView = (context: IRegistrationWizardTrackingContext) => {
    trackAmplitudeEvent("auth_form_view", {
        auth_method: "internal",
        auth_placement: context.authPlacement,
        location: context.location
    });
};

export const trackRegistrationWizardStepView = (context: IRegistrationWizardTrackingContext, step: Exclude<RegistrationWizardStepToken, "auth">) => {
    trackAmplitudeViewModal({
        modalName: step,
        location: context.location,
        authPlacement: context.authPlacement,
        ...(step === "phone_verify" && {phoneVerifyPlacement: context.authPlacement})
    });
};

export const getRegistrationWizardPhoneVerificationContext = (context: IRegistrationWizardTrackingContext): IAmplitudePhoneVerificationContext => ({
    location: context.location,
    phoneVerifyPlacement: context.authPlacement,
    authPlacement: context.authPlacement
});

export const trackRegistrationWizardPhoneAbandoned = (context: IRegistrationWizardTrackingContext) => {
    trackAmplitudePhoneVerified(false, getRegistrationWizardPhoneVerificationContext(context));
};

export const trackRegistrationWizardButtonClick = (
    context: IRegistrationWizardTrackingContext,
    buttonName: AmplitudeRegistrationWizardButtonName,
    step: RegistrationWizardStepToken | null = null
) => {
    trackAmplitudeButtonClick({
        buttonName,
        buttonCategory: "rp_auth",
        itemId: context.itemId,
        propertyId: context.propertyId,
        value: step,
        additionalEventProperties: {auth_placement: context.authPlacement}
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeRegistrationWizardButtonName, trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {trackAmplitudeViewModal} from "../../tracking/amplitude/track_amplitude_view_modal";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {IAmplitudePhoneVerificationContext, trackAmplitudePhoneVerified} from "../../user/tracking/track_amplitude_phone_verified";
import {AmplitudeAuthLocation} from "./track_amplitude_auth_event";

export interface IRegistrationWizardTrackingContext {
    authPlacement: AmplitudeAuthPlacement | null;
    location: AmplitudeAuthLocation;
    itemId: number | null;
    propertyId: number | null;
}

export type RegistrationWizardStepToken = "auth" | "auth_phone" | "phone_verify" | "auth_name";

export const trackRegistrationWizardFormView = (context: IRegistrationWizardTrackingContext) => {
    trackAmplitudeEvent("auth_form_view", {
        auth_method: "internal",
        auth_placement: context.authPlacement,
        location: context.location
    });
};

export const trackRegistrationWizardStepView = (context: IRegistrationWizardTrackingContext, step: Exclude<RegistrationWizardStepToken, "auth">) => {
    trackAmplitudeViewModal({
        modalName: step,
        location: context.location,
        authPlacement: context.authPlacement,
        ...(step === "phone_verify" && {phoneVerifyPlacement: context.authPlacement})
    });
};

export const getRegistrationWizardPhoneVerificationContext = (context: IRegistrationWizardTrackingContext): IAmplitudePhoneVerificationContext => ({
    location: context.location,
    phoneVerifyPlacement: context.authPlacement,
    authPlacement: context.authPlacement
});

export const trackRegistrationWizardPhoneAbandoned = (context: IRegistrationWizardTrackingContext) => {
    trackAmplitudePhoneVerified(false, getRegistrationWizardPhoneVerificationContext(context));
};

export const trackRegistrationWizardButtonClick = (
    context: IRegistrationWizardTrackingContext,
    buttonName: AmplitudeRegistrationWizardButtonName,
    step: RegistrationWizardStepToken | null = null
) => {
    trackAmplitudeButtonClick({
        buttonName,
        buttonCategory: "rp_auth",
        itemId: context.itemId,
        propertyId: context.propertyId,
        value: step,
        additionalEventProperties: {auth_placement: context.authPlacement}
    });
};
